import { j as t } from "../../../../jsx-runtime-B6kdoens.js";
import { a as o } from "../../../../index-CROKJrb5.js";
import { c as m, f as x } from "../../../../create-component-CBAeEoQ6.js";
const i = m(
  "TextCardLabels",
  x(
    ({ children: r, className: a, ...e }, s) => /* @__PURE__ */ t.jsx(
      "div",
      {
        ref: s,
        className: o("cur-flex cur-flex-wrap cur-gap-1", a),
        ...e,
        children: r
      }
    )
  )
);
export {
  i as TextCardLabels
};
//# sourceMappingURL=index.js.map
